import { CdkDrag, CdkDragDrop, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
import { DatePipe, NgClass, registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { AfterViewInit, Component, ElementRef, HostListener, inject, LOCALE_ID, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { IconDefinition } from '@ant-design/icons-angular';
import {
    AppstoreAddOutline,
    AppstoreOutline,
    FileDoneOutline,
    FundViewOutline,
    PlusOutline
} from '@ant-design/icons-angular/icons';
import _ from 'lodash';
import { ɵNzTransitionPatchDirective } from 'ng-zorro-antd/core/transition-patch';
import { NzDividerComponent } from 'ng-zorro-antd/divider';
import { NzDrawerComponent, NzDrawerContentDirective } from 'ng-zorro-antd/drawer';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzFormControlComponent, NzFormDirective, NzFormItemComponent, NzFormModule } from 'ng-zorro-antd/form';
import { NzColDirective, NzRowDirective } from 'ng-zorro-antd/grid';
import { NzIconDirective, NzIconModule, NzIconService } from 'ng-zorro-antd/icon';
import { NzInputDirective, NzInputGroupComponent, NzInputGroupWhitSuffixOrPrefixDirective } from 'ng-zorro-antd/input';
import { NzMessageModule, NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzPageHeaderComponent, NzPageHeaderExtraDirective } from 'ng-zorro-antd/page-header';
import { NzProgressComponent } from 'ng-zorro-antd/progress';
import { NzOptionComponent, NzSelectComponent, NzSelectModule } from 'ng-zorro-antd/select';
import { NzTableCellDirective, NzTableComponent, NzTableFilterList, NzTableFixedRowComponent, NzTableModule, NzTableQueryParams, NzTableSortOrder, NzTbodyComponent, NzTdAddOnComponent, NzTheadComponent, NzThMeasureDirective, NzTrDirective, NzTrExpandDirective } from 'ng-zorro-antd/table';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { Subject, takeUntil } from 'rxjs';
import { DRAWER_WIDTH_CHANGE_PLACEMENT, WIDTH_VIEW_LIST_COMPONENT_ACTIONS } from 'src/app/core/constants/components';
import { ORDERS } from 'src/app/core/constants/storage';
import { TITLE_TABLE_SIZE } from 'src/app/core/constants/style';
import { DrawerMode } from 'src/app/core/enums/drawer-mode';
import { UserLoggedService } from 'src/app/core/services/userLogged.service';
import { ArticleBatchDto } from 'src/app/shared/dto/article-batch.dto';
import { ArticleDto } from 'src/app/shared/dto/article.dto';
import { AssessDto } from 'src/app/shared/dto/assess.dto';
import { CustomerDto } from 'src/app/shared/dto/customer.dto';
import { FinalProductDto } from 'src/app/shared/dto/final-product.dto';
import { MachineDto } from 'src/app/shared/dto/machine.dto';
import { PriorityDto } from 'src/app/shared/dto/priority.dto';
import { ProductionOrderProcessDto } from 'src/app/shared/dto/production-order-process.dto';
import { ProductionPauseDto } from 'src/app/shared/dto/production-pause.dto';
import { ProductionProcessDto } from 'src/app/shared/dto/production-process.dto';
import { ProductionRouteDto } from 'src/app/shared/dto/production-route.dto';
import { RawMaterialDto } from 'src/app/shared/dto/rawMaterial.dto';
import { UserDto } from 'src/app/shared/dto/user.dto';
import { StatusEnum } from 'src/app/shared/enums/production-order-state-ids.enum';
import { ProductionOrderStatesEnum } from 'src/app/shared/enums/production-order-states.enum';
import { ModalSelectFinalProductsComponent } from '../../components/modals/modal-select-final-products/modal-select-final-products.component';
import { ArticleBatchesService } from '../../services/article-batches.service';
import { ArticlesService } from '../../services/articles.service';
import { AssessService } from '../../services/assess.service';
import { CustomersService } from '../../services/customers.service';
import { MachineService } from '../../services/machine.service';
import { ProductionOrderService } from '../../services/production-order.service';
import { ProductionProcessesService } from '../../services/production-processes.service';
import { ProductionRoutesService } from '../../services/production-routes.service';
import { StatusesService } from '../../services/statuses.service';
import { UserService } from '../../services/user.service';
import { ProductionOrderDto } from './../../../shared/dto/production-order.dto';
import { LocalStorageService } from 'src/app/core/services/storage.service';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';
import { DefaultComponent } from 'src/app/shared/services/view.service';
import { ScreenLoggedService } from 'src/app/core/services/screenLogged.service';
import { ScreenDto } from 'src/app/shared/dto/screen.dto';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { showDialog } from 'src/app/shared/utils/utils';
import { ProductionOrderProcessesService } from '../../services/production-order-processes.service';
import { ConfigurationService } from '../../services/configuration.service';
import { ProductionOrderResponseDto } from 'src/app/shared/dto/pagination/production-order-response.dto';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { ModalAddRawMaterialsToUseComponent } from '../../components/modals/modal-add-raw-materials-to-use/modal-add-raw-materials-to-use.component';
import { RawMaterialToUseDto } from 'src/app/shared/dto/raw-material-to-use.dto';
registerLocaleData(localeEs);

const icons: IconDefinition[] = [
    PlusOutline,
    FundViewOutline,
    AppstoreAddOutline,
    AppstoreOutline,
    FileDoneOutline
];

@Component({
    selector: 'app-production-orders',
    templateUrl: './production-orders.component.html',
    styleUrl: './production-orders.component.scss',
    standalone: true,
    providers: [
        { provide: LOCALE_ID, useValue: 'es-ES' }
    ],
    imports: [
        NzPageHeaderComponent,
        NzPageHeaderExtraDirective,
        NzInputGroupComponent,
        ɵNzTransitionPatchDirective,
        NzInputGroupWhitSuffixOrPrefixDirective,
        ReactiveFormsModule,
        FormsModule,
        NzIconDirective,
        NzTableComponent,
        NzTheadComponent,
        NzTrDirective,
        NzTableCellDirective,
        NzThMeasureDirective,
        NzTbodyComponent,
        NzTdAddOnComponent,
        NgClass,
        NzProgressComponent,
        NzDividerComponent,
        NzTrExpandDirective,
        NzTableFixedRowComponent,
        NzDrawerComponent,
        NzDrawerContentDirective,
        NzSelectComponent,
        NzOptionComponent,
        CdkDropList,
        CdkDrag,
        DatePipe,
        NzMessageModule,
        NzTableModule,
        NzSelectModule,
        NzInputDirective,
        NzFormDirective,
        NzRowDirective,
        NzFormItemComponent,
        NzColDirective,
        NzFormControlComponent,
        NzFormModule,
        NzIconModule,
        NzToolTipModule,
        NzDropDownModule,
        LoaderComponent,
        NzButtonModule,
        NzDatePickerModule
    ]
})

export class ProductionOrdersComponent extends DefaultComponent implements OnInit, OnDestroy, AfterViewInit {

    @ViewChild('nestedTable', { static: false }) table?: NzTableComponent<ProductionOrderDto>;
    @ViewChild('innerTable', { static: false }) innerTable?: NzTableComponent<any>;
    @ViewChild('tableContainer') private readonly _tableContainer!: ElementRef;

    public ProductionOrderStates = ProductionOrderStatesEnum;
    public ProductionOrderStateIdsEnum = StatusEnum;

    totalOrders: number = 0;
    isLoading: boolean = true;
    pageSize: number = 10;
    pageIndex: number = 1;
    isSaving: boolean = false;

    productionOrders: ProductionOrderDto[] = [];
    productionOrdersFiltered: ProductionOrderDto[] = [];
    drawerMode: DrawerMode = DrawerMode.NONE;

    private expandedOrderIds: number[] = [];
    private sort: {
        key: string;
        value: NzTableSortOrder;
    }[] = [];
    private filter: {
        key: string;
        value: NzTableFilterList;
    }[] = [];

    tableHeight!: number;
    customerName: string = '';
    filterText: string = '';
    filterMultipleProcessesRunning: boolean = false;
    filterMachineId: number | null = null;
    orderSelected: ProductionOrderDto | null = null;
    drawerVisible: boolean = false;
    drawerTitle: string = '';
    fieldsReadOnly: boolean = true;
    startDate: Date = new Date();
    deadlineDate: Date = new Date();
    confirmationDate: Date = new Date();
    deliveryDate: Date = new Date();
    selectedEditOrder: ProductionOrderDto = new ProductionOrderDto();
    isNewOrder: boolean = false;
    customerSelected: CustomerDto = new CustomerDto();
    customers: CustomerDto[] = [];
    routes: ProductionRouteDto[] = [];
    routeSelected: ProductionRouteDto | undefined;
    articles: ArticleDto[] = [];
    originalArticleStocks: ArticleDto[] = [];
    articleSelected: ArticleDto = new ArticleDto();
    productionProcessess: ProductionProcessDto[] = [];
    selectedProductionProcesses: ProductionProcessDto[] = [];
    previousProductionProcessTableRows: ProductionProcessDto[] = [];
    productionProcessTableRows: ProductionOrderProcessDto[] = [];
    machines: MachineDto[] = [];
    machineSelected: MachineDto = new MachineDto();
    assessments: AssessDto[] = [];
    assessSelected: AssessDto = new AssessDto();
    priorities: PriorityDto[] = [];
    prioritySelected: PriorityDto = new PriorityDto();
    priorityOrder: number = 0;
    orderStarted: boolean = false;
    users: UserDto[] = [];
    selectedUsers: UserDto[] = [];
    userLogged: UserDto;
    totalQuantityFinalProducts: number = 0;
    loggedScreen: ScreenDto | null = null;
    idColumnValueToShow: string = 'id';
    multipleMachines: boolean = false;
    selectableMachines: MachineDto[] = [];

    public innerWidth: number = 0;
    public DRAWER_WIDTH_CHANGE_PLACEMENT = DRAWER_WIDTH_CHANGE_PLACEMENT;
    public WIDTH_VIEW_LIST_COMPONENT_ACTIONS = WIDTH_VIEW_LIST_COMPONENT_ACTIONS;

    filterStatus: { text: string, value: number, byDefault: boolean }[] = [];

    private articlesBatches: ArticleBatchDto[] = [];
    private isInitialLoad: boolean = true;
    private unsubscribe$ = new Subject<void>();

    private readonly productionOrderService = inject(ProductionOrderService);
    private readonly productionOrderProcessesService = inject(ProductionOrderProcessesService);
    private readonly toast = inject(NzMessageService);
    private readonly router = inject(Router);
    private readonly userLoggedService = inject(UserLoggedService);
    private readonly activatedRoute = inject(ActivatedRoute);
    private readonly ordersService = inject(ProductionOrderService);
    private readonly customerService = inject(CustomersService);
    private readonly productionRouteService = inject(ProductionRoutesService);
    private readonly articleService = inject(ArticlesService);
    private readonly articleBatchesService = inject(ArticleBatchesService);
    private readonly productionProcessesService = inject(ProductionProcessesService);
    private readonly machineService = inject(MachineService);
    private readonly assessService = inject(AssessService);
    private readonly modalService = inject(NzModalService);
    private readonly usersService = inject(UserService);
    private readonly iconService = inject(NzIconService);
    private readonly statusesService = inject(StatusesService);
    private readonly localStorageService = inject(LocalStorageService);
    private readonly screenLoggedService = inject(ScreenLoggedService);
    private readonly configurationService = inject(ConfigurationService);

    constructor() {
        super('productionOrders', '');
        this.iconService.addIcon(...icons);
        this.activatedRoute.queryParams
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((params) => {
                const customerNameParam = params['customerName'];

                if (customerNameParam !== null && customerNameParam !== undefined) {
                    this.customerName = params['customerName'];
                }
            });

        this.loggedScreen = this.screenLoggedService.screenLogged;
        this.userLogged = _.cloneDeep(this.userLoggedService.userLogged);
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.innerWidth = window.innerWidth;
    }

    async ngOnInit(): Promise<void> {

        this.isLoading = true;
        this.innerWidth = window.innerWidth;
        this.filterText = sessionStorage.getItem('lastFilter') ?? '';
        this.filterMultipleProcessesRunning = (await this.configurationService.getConfigurationByKey('productionOrders.multipleProcessesRunning')).value === 'true'
        this.idColumnValueToShow = (await this.configurationService.getConfigurationByKey('order.idColumnValue')).value.toString() ?? 'id';

        await this.statusesService.setupWebSocket();
        this.statusesService.statuses$
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe({
                next: (statuses) => {
                    this.filterStatus = [];
                    for (const status of statuses) {
                        if (
                            this.showWithProductionOrdersPermissions('canFilterFinished') ||
                            (!this.showWithProductionOrdersPermissions('canFilterFinished') && status.id !== StatusEnum.FINISHED && status.id !== StatusEnum.CANCELLED)
                        ) {
                            this.filterStatus.push({
                                text: status.name,
                                value: status.id,
                                byDefault: status.id === StatusEnum.FINISHED || status.id === StatusEnum.CANCELLED ? false : true
                            });
                        }
                    }
                    this.filterStatus = _.cloneDeep(this.filterStatus);
                },
                error: () => {
                    this.toast.error('Error cargando estados');
                }
            });

        // La suscripción a orders$ y la configuración del WebSocket se hace después de cargar los estados
        // para que los filtros estén disponibles cuando se haga la primera llamada

        await this.articleService.setupWebSocket();
        this.articleService.articles$
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe({
                next: (articles) => {
                    this.articles = articles;
                    this.originalArticleStocks = _.cloneDeep(this.articles);
                    this.articleSelected = this.articles[this.articles.length - 1];
                },
                error: () => {
                    this.toast.error('Error cargando artículos');
                }
            });

        await this.machineService.setupWebSocket();
        this.machineService.machines$
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe({
                next: (machines) => {
                    this.machines = machines;
                    this.getVisibleMachinesForUser();
                },
                error: () => {
                    this.toast.error('Error cargando máquinas');
                }
            });

        await this.assessService.setupWebSocket();
        this.assessService.assessments$
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe({
                next: (assessments) => {
                    this.assessments = assessments;
                    this.assessSelected = this.assessments[this.assessments.length - 1];
                },
                error: () => {
                    this.toast.error('Error cargando evaluaciones');
                }
            });

        await this.customerService.setupWebSocket();
        this.customerService.customers$
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe({
                next: (customers) => {
                    this.customers = customers;
                    this.customerSelected = this.customers[this.customers.length - 1];
                },
                error: () => {
                    this.toast.error('Error cargando clientes');
                }
            });

        await this.productionRouteService.setupWebSocket();
        this.productionRouteService.productionRoutes$
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe({
                next: (routes) => {
                    this.routes = routes;
                    const previousIndexRouteSelected = this.routes.findIndex(route => route.id === this.routeSelected?.id);
                    this.routeSelected = this.routes[previousIndexRouteSelected ?? null];

                    if (this.routeSelected) {
                        const newProductionProcessSelectedIds = this.routeSelected.productionProcesses?.map(process => process.productionProcessId);
                        const newProductionProcessessSelected = newProductionProcessSelectedIds!
                            .map(id => this.productionProcessess.find(process => process.id === id))
                            .filter((process): process is ProductionProcessDto => process !== undefined);

                        if (newProductionProcessessSelected.length > 0) {
                            this.onProductionProcessessChange(newProductionProcessessSelected, true);
                        }

                        this.onRouteChange(this.routeSelected);
                    }
                },
                error: () => {
                    this.toast.error('Error cargando rutas de producción');
                }
            });

        await this.productionProcessesService.setupWebSocket();
        this.productionProcessesService.productionProcessess$
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe({
                next: (productionProcessess) => {
                    this.productionProcessess = productionProcessess;
                },
                error: () => {
                    this.toast.error('Error cargando procesos de producción');
                }
            });

        await this.articleBatchesService.setupWebSocket();
        this.articleBatchesService.articleBatches$
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe({
                next: (articleBatches) => {
                    this.articlesBatches = articleBatches;
                },
                error: () => {
                    this.toast.error('Error cargando lotes de artículos');
                }
            });

        await this.usersService.setupWebSocket();
        this.usersService.users$
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe({
                next: (users) => {
                    this.users = users;
                },
                error: () => {
                    this.toast.error('Error cargando ordenes de producción');
                }
            });

        this.priorities = await this.productionOrderService.getPriorities();
        this.prioritySelected = this.priorities[0];

        this.resetProductionProcessesData();

        // Conectar WebSocket sin hacer llamada HTTP inicial
        // La primera carga se hace a través de onQueryParamsChange cuando la tabla se inicializa
        this.productionOrderService.setupWebSocketOnly();
        this.productionOrderService.orders$
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe({
                next: (orders) => {
                    if (orders.orders.length > 0 || orders.totalOrders === 0) {
                        this.productionOrders = orders.orders;
                        this.totalOrders = orders.totalOrders;
                        this.saveExpandedOrderIds();
                        this.productionOrdersFiltered = _.cloneDeep(this.productionOrders);
                        this.restoreExpandedOrderState();
                        this.selectedEditOrder = this.productionOrders.find(order => order.id === this.selectedEditOrder.id) ?? this.selectedEditOrder;

                        if (this.selectedEditOrder.id) {
                            this.prioritySelected = this.selectedEditOrder.priority ?? this.priorities[0];
                            this.customerSelected = this.selectedEditOrder.customers ?? this.customers[0];
                            this.routeSelected = this.selectedEditOrder.productionRoute ?? undefined;

                            this.selectedProductionProcesses = [];
                            this.selectedEditOrder.productionOrderProcesses?.forEach(orderProcess => {
                                if (!this.selectedProductionProcesses.some((process) => process.id === orderProcess.productionProcess.id)) {
                                    this.selectedProductionProcesses = [...this.selectedProductionProcesses, orderProcess.productionProcess];
                                }
                            });

                            this.productionProcessTableRows = this.selectedEditOrder.productionOrderProcesses ?? [];
                            this.selectedUsers = this.selectedEditOrder.operators ?? [];
                        }
                    }
                },
                error: () => {
                    this.toast.error('Error cargando ordenes de producción');
                }
            });

        // isLoading se establece a false cuando getPaginatedOrders() termina
        // La primera llamada vendrá de onQueryParamsChange
    }

    ngOnDestroy(): void {
        this.productionOrderService.disconnectWebSocket();
        this.articleService.disconnectWebSocket();
        this.machineService.disconnectWebSocket();
        this.assessService.disconnectWebSocket();
        this.customerService.disconnectWebSocket();
        this.productionRouteService.disconnectWebSocket();
        this.articleBatchesService.disconnectWebSocket();
        this.productionProcessesService.disconnectWebSocket();
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    async ngAfterViewInit(): Promise<void> {
        this.innerWidth = window.innerWidth;
        setTimeout(() => {
            this.tableHeight =
                (this._tableContainer.nativeElement as HTMLImageElement)
                    .clientHeight - TITLE_TABLE_SIZE; // X depend of your page display
        });
    }

    async onQueryParamsChange(params: NzTableQueryParams): Promise<void> {
        const { pageSize, pageIndex, sort, filter } = params;

        this.sort = sort;
        this.filter = filter;
        this.pageSize = pageSize;
        this.pageIndex = pageIndex;

        // Permitir la primera carga o cargas subsecuentes cuando no esté cargando
        if (this.isInitialLoad || !this.isLoading) {
            this.isInitialLoad = false;
            await this.getPaginatedOrders();
        }
    }

    async getPaginatedOrders() {
        this.isLoading = true;
        this.saveExpandedOrderIds();

        try {
            const ordersResponse: ProductionOrderResponseDto = await this.productionOrderService.getPaginatedOrders(
                this.pageSize,
                this.pageIndex,
                this.filterText,
                this.filterMultipleProcessesRunning,
                this.filterMachineId,
                this.filter,
                this.sort
            );

            this.totalOrders = ordersResponse.total;
            this.pageIndex = ordersResponse.page ?? this.pageIndex;
            this.productionOrders = ordersResponse.productionOrders;
            this.productionOrdersFiltered = _.cloneDeep(this.productionOrders);

            this.restoreExpandedOrderState();

            // Actualizar las variables del servicio para que el WebSocket use los mismos filtros
            this.productionOrderService.refreshVariables(
                this.pageSize,
                this.pageIndex,
                this.filterText,
                this.filterMultipleProcessesRunning,
                this.filterMachineId,
                this.filter,
                this.sort
            );

            // Emitir al subject para mantener sincronizado el estado (útil para el WebSocket)
            this.productionOrderService.emitOrders(ordersResponse.productionOrders, ordersResponse.total);
        } finally {
            this.isLoading = false;
        }
    }

    onMachineFilterChange(machineId: number | null): void {
        this.filterMachineId = machineId;
        this.getPaginatedOrders();
    }

    calculateStepper(order: ProductionOrderDto): number {
        const orderProcesses = order.productionOrderProcesses || [];

        let totalDone: number = 0;

        for (let index = 0; index < orderProcesses.length; index++) {
            const orderProcess = orderProcesses[index];
            totalDone += this.calculateProcessProgress(orderProcess);
        }

        return totalDone = totalDone === 0 ? 0 : Math.round((totalDone / orderProcesses.length) * 100) / 100;
    }

    calculateProcessProgress(orderProcess: ProductionOrderProcessDto): number {

        if (orderProcess.status?.id === StatusEnum.FINISHED) {
            return 100;
        }

        if (!orderProcess.finalProducts) {
            return 0;
        }

        const quantityToProduce = orderProcess.finalProducts.reduce((total: any, finalProduct) => {
            return total + (finalProduct.quantityToProduce || 0);
        }, 0);

        const quantityProduced = orderProcess.finalProducts.reduce((total: any, finalProduct) => {
            return total + (finalProduct.quantityProduced || 0);
        }, 0);

        return (quantityProduced === 0 || quantityToProduce === 0) ? 0 : Math.min(100, Math.round((quantityProduced / quantityToProduce) * 100));
    }

    setOrderSelected(event: any, order: any): void {
        if (this.orderSelected && order) {
            const orderFound = this.productionOrdersFiltered.find(
                (orderA: any) => orderA.id === (this.orderSelected as ProductionOrderDto).id,
            );

            if (this.orderSelected.id !== order.id) {
                this.orderSelected = _.cloneDeep(order);
                order.expand = true;
            } else {
                this.orderSelected = _.cloneDeep(null);
                order.expand = false;
            }
        } else {
            this.orderSelected = _.cloneDeep(order);
            if (order) {
                order.expand = true;
            }
        }
    }

    async customerFilter(customerName: string): Promise<void> {
        this.customerName = customerName;
        this.filterText = customerName;
        await this.getPaginatedOrders();
    }

    navigateToOrder(orderId: number): void {
        const order = this.productionOrders.find(o => o.id === orderId);

        this.localStorageService.setItem(ORDERS, order);

        this.router.navigate([`/production-orders/${orderId}`]);

    }

    navigateToProcess(orderId: number): void {
        const machineIds = this.loggedScreen?.machines?.map((machine) => machine.id);
        const orderSelected = this.productionOrdersFiltered.find((order) => order.id === orderId);
        const process = orderSelected?.productionOrderProcesses!.find((process) =>
            (process.statusId !== StatusEnum.FINISHED)
            && (machineIds?.includes(process.machine?.id as number || process.machineId as number))
        );
        if (process) {
            this.router.navigate([`/production-orders/${orderId}/process/${process.id}`]);
        }
    }

    navigateToProcessByIdOrderAndProcessId(orderId: number, processId: number): void {
        this.router.navigate([`/production-orders/${orderId}/process/${processId}`]);
    }

    async forceFinishProduction(orderId: number, productionOrderProcess: ProductionOrderProcessDto) {
        if (await showDialog(this.modalService, `Vas a finalizar el proceso ${productionOrderProcess.productionProcess.name}. Esta acción no se puede revertir, ¿deseas continuar con la finalización del proceso?`)) {
            try {
                //TODO: REVIEW WHEN FORCE UPDATE FUNCTION FIXED
                await this.productionOrderProcessesService.setProductionProcessAsFinished(orderId, productionOrderProcess.id!, this.userLogged.id);
                this.toast.success(`Proceso ${productionOrderProcess.productionProcess.name} finalizado correctamente`);
            } catch (error: any) {
                this.toast.error(error.message);
            }
        }
    }

    getTotalDuration(startDate: Date, endDate: Date, pauses: ProductionPauseDto[]): string {
        //TODO: Revisar si concuerdan los tiempos
        let pausesMilliseconds: number = 0;

        for (let i = 0; i < pauses.length; i++) {
            const pausa = pauses[i];
            pausesMilliseconds += new Date(pausa.startDate).getTime() - new Date(pausa.endDate).getTime();
        }

        const millisec: number = new Date(endDate).getTime() - new Date(startDate).getTime();
        const millisecToUse: number = millisec - pausesMilliseconds;

        let seconds: number = +(millisecToUse / 1000).toFixed(0);
        let minutes: number = Math.floor(seconds / 60);
        let hours: number = 0;

        if (minutes > 59) {
            hours = Math.floor(minutes / 60);
            minutes = minutes - hours * 60;
        }

        seconds = Math.floor(seconds % 60);

        if (hours > 0) {
            return `${hours >= 10 ? '' : '0'}${hours} : ${minutes >= 10 ? '' : '0'}${minutes} : ${seconds >= 10 ? '' : '0'}${seconds}`;
        }

        return `${minutes >= 10 ? '' : '0'}${minutes} : ${seconds >= 10 ? '' : '0'}${seconds}`;
    }

    saveLastTextFilter() {
        sessionStorage.setItem('lastFilter', this.filterText);
    }

    async clearFilter(): Promise<void> {
        this.filterText = '';
        this.customerName = '';
        this.pageIndex = 1;

        sessionStorage.setItem('lastFilter', '');

        await this.getPaginatedOrders();
    }

    async openCreateOrderDrawer(): Promise<void> {
        try {
            this.fieldsReadOnly = false;
            this.selectedEditOrder = new ProductionOrderDto();
            this.drawerTitle = 'Creando nueva orden de producción';
            this.prioritySelected = this.priorities[0];
            this.isNewOrder = true;
            this.productionProcessTableRows = [];
            this.customerSelected = new CustomerDto();
            this.customerSelected = new CustomerDto();
            this.orderStarted = false;
            this.openDrawer();
        } catch (e: any) {
            this.toast.create('error', `${e.message}`);

            this.closeDrawer();
        }
    }

    viewOrder(id: number): void {
        this.fieldsReadOnly = true;
        this.drawerMode = DrawerMode.VIEW;
        this.selectedEditOrder = this.productionOrdersFiltered.find(
            (order) => order.id === id
        ) as ProductionOrderDto;

        this.drawerTitle = 'Viendo orden de producción ' + this.selectedEditOrder?.id;

        this.startDate = this.selectedEditOrder.startDate
            ? new Date(this.selectedEditOrder.startDate)
            : new Date();

        this.deadlineDate = this.selectedEditOrder.deadlineDate
            ? new Date(this.selectedEditOrder.deadlineDate)
            : new Date();

        this.confirmationDate = this.selectedEditOrder.confirmationDate
            ? new Date(this.selectedEditOrder.confirmationDate)
            : new Date();

        this.deliveryDate = this.selectedEditOrder.deliveryDate
            ? new Date(this.selectedEditOrder.deliveryDate)
            : new Date();
        this.orderStarted = false;
        this.setData();
        this.openDrawer();
    }

    editOrder(id: number): void {
        this.drawerMode = DrawerMode.EDIT;
        this.selectedEditOrder = this.productionOrdersFiltered.find(
            (order) => order.id === id
        ) as ProductionOrderDto;

        this.orderStarted = this.selectedEditOrder.productionOrderProcesses?.some(
            (p) => !p.status?.isStartingStatus
        ) as boolean;

        this.fieldsReadOnly = false;
        this.drawerTitle = 'Editando orden de producción ' + this.selectedEditOrder?.id;
        this.isNewOrder = false;
        this.setData();
        this.openDrawer();
    }

    compareUsers = (o1: any, o2: any): boolean => {
        return o1 && o2 ? o1.id === o2.id : o1 === o2;
    };

    setData(): void {
        try {
            this.customerSelected = this.customers.find(
                (c) => c.id === (this.selectedEditOrder.customers as CustomerDto)?.id
            ) as CustomerDto;

            if (this.selectedEditOrder.productionRoute) {
                this.routeSelected = this.routes.find(
                    (r) => r.id === (this.selectedEditOrder.productionRoute as ProductionRouteDto).id
                );
            }

            this.prioritySelected = this.priorities.find(
                (p) => p.id === this.selectedEditOrder.priorityId
            ) as PriorityDto;

            this.selectedUsers = [...this.selectedEditOrder?.operators!];

            this.productionProcessTableRows = [];

            (this.selectedEditOrder.productionOrderProcesses as ProductionOrderProcessDto[]).forEach((orderProcess: ProductionOrderProcessDto) => {
                const foundProcess = this.productionProcessess.find((process) => process.id === orderProcess.productionProcess!.id);

                if (!foundProcess) {
                    return;
                }

                if (!this.selectedProductionProcesses.some((process) => process.id === foundProcess.id)) {
                    this.selectedProductionProcesses.push(foundProcess);
                }

                this.previousProductionProcessTableRows.push(foundProcess);

                const createdOrderProcess: ProductionOrderProcessDto = {
                    id: orderProcess.id,
                    productionProcess: foundProcess,
                    description: orderProcess.description,
                    machine: this.machines.find((machine) => machine.id === orderProcess.machine?.id) as MachineDto,
                    finalProducts: orderProcess.finalProducts,
                    order: orderProcess.order,
                    assess: this.assessments.find((assess) => assess.id === orderProcess.assess?.id) as AssessDto,
                    rawMaterialsUsed: orderProcess.rawMaterialsUsed,
                    rawMaterialsToUse: orderProcess.rawMaterialsToUse,
                    status: orderProcess.status
                };

                this.productionProcessTableRows.push(createdOrderProcess);
            });

        } catch (e: any) {
            this.toast.create('error', `Error inicializando. Error: ${e.message}`);
        }
    }

    async deleteOrder(orderId: number): Promise<void> {
        try {

            this.selectedEditOrder = this.productionOrdersFiltered.find(
                (order) => order.id === orderId
            ) as ProductionOrderDto;

            this.orderStarted = this.selectedEditOrder.productionOrderProcesses?.some(
                (p) => !p.status?.isStartingStatus
            ) as boolean;

            if (this.orderStarted) {
                this.toast.error('No se puede eliminar una orden que ya ha sido iniciada');
                return;
            }

            const deleteConfirmation: boolean = window.confirm(`¿Estás seguro de que quieres eliminar la orden de producción ${orderId}? Esta acción no se puede deshacer.`);

            if (!deleteConfirmation) {
                return;
            }

            const deletedOrderResponse: ProductionOrderDto = await this.ordersService.deleteOrder(orderId);

            if (!deletedOrderResponse) {
                this.toast.create('error', `Ha habido un error eliminando la orden de producción ${orderId}`);
            }

            this.toast.create('success', 'Orden de producción eliminada correctamente');
        } catch (e: any) {
            this.toast.create('error', `Error eliminando la orden de producción ${orderId}. Error: ${e.message}`);
        }
    }

    async submitForm(): Promise<void> {
        try {
            this.isSaving = true;
            const order: ProductionOrderDto = {
                id: this.selectedEditOrder.id,
                description: (<HTMLInputElement>(document.getElementById('description'))).value ? ((<HTMLInputElement>document.getElementById('description')).value as string) : '',
                priorityId: this.prioritySelected.id as number,
                priorityOrder: (<HTMLInputElement>(document.getElementById('priorityOrder'))).value ? +(<HTMLInputElement>document.getElementById('priorityOrder')).value : 0,
                reference: (<HTMLInputElement>(document.getElementById('reference'))).value ? ((<HTMLInputElement>document.getElementById('reference')).value as string) : '',
                customers: this.customerSelected,
                startDate: this.startDate,
                deadlineDate: this.deadlineDate,
                confirmationDate: this.confirmationDate,
                deliveryDate: this.deliveryDate,
                customerId: this.customerSelected?.id,
                productionOrderProcesses: this.productionProcessTableRows.map((pp) => {
                    const process = _.cloneDeep(pp);
                    process.finalProducts = pp.finalProducts;

                    process.rawMaterialsToUse = process.rawMaterialsToUse?.map((rm) => {
                        const rawMaterialToUse = _.cloneDeep(rm);

                        rawMaterialToUse.articleId = rm.article?.id;

                        if (rawMaterialToUse.articleId != undefined) {
                            delete rawMaterialToUse.article;
                        }

                        return rawMaterialToUse;
                    });

                    return process;
                }),
                productionRouteId: this.routeSelected?.id,
                statusId: this.isNewOrder ? StatusEnum.AWAITING : this.selectedEditOrder.statusId,
                operators: this.selectedUsers
            };

            if (!this.isValidForm(order)) {
                this.isSaving = false;
                return;
            }

            if (this.isNewOrder) {
                const createdOrder: ProductionOrderDto = await this.ordersService.createOrder(order);

                this.productionOrders[this.productionOrders.length === 0 ? 0 : this.productionOrders.length - 1] = createdOrder;
                this.productionOrdersFiltered = _.cloneDeep(this.productionOrders);

                this.isSaving = false;
                this.toast.create('success', 'Orden creada correctamente');
            } else if (this.orderStarted) {
                const orderIndex: number = this.productionOrders.findIndex(o => o.id === order.id);

                await this.productionOrderService.updateOrder(order);
                this.productionOrdersFiltered = _.cloneDeep(this.productionOrders);

                this.isSaving = false;
                this.toast.create('success', 'Prioridad de la orden actualizada correctamente');
                this.closeDrawer();

            } else {
                const orderIndex: number = this.productionOrders.findIndex(o => o.id === order.id);
                this.productionOrders[orderIndex] = await this.ordersService.updateOrder(order);
                this.productionOrdersFiltered = _.cloneDeep(this.productionOrders);

                this.isSaving = false;
                this.toast.create('success', 'Orden actualizada correctamente');
            }

            this.closeDrawer();
        } catch (e: any) {
            this.isSaving = false;
            this.toast.create('error', `No se ha podido guardar correctamente la orden. ${e.message}`);
        }
    }

    async setSelectedOrderAsUrgent() {
        try {
            if (!this.orderSelected || !this.orderSelected.id) {
                this.toast.create('error', 'No se ha seleccionado ninguna orden de producción');
                return;
            }

            const highestPriorityIndex: number = this.priorities[this.priorities.length - 1].id ?? -1;

            if (highestPriorityIndex < 0) {
                this.toast.create('error', 'No se ha podido encontrar la prioridad más alta');
                return;
            }

            if (this.orderSelected.priorityId === highestPriorityIndex) {
                this.toast.create('error', 'La orden seleccionada ya tiene la prioridad más alta');
                return;
            }

            const orderIndex: number = this.productionOrders.findIndex(o => o.id === this.orderSelected?.id);

            this.productionOrders[orderIndex] = await this.ordersService.setAsUrgent(this.orderSelected.id);

            this.toast.create('success', `Orden ${this.orderSelected.id} marcada como urgente`);
        } catch (e: any) {
            this.toast.create('error', `No se ha podido marcar la orden como urgente. ${e.message}`);
        }
    }

    cancelEditing(): void {
        this.resetProductionProcessesData();
        this.routeSelected = undefined;
        this.closeDrawer();
    }

    openDrawer(): void {
        this.drawerVisible = true;
    }

    closeDrawer(): void {
        this.routeSelected = undefined;
        this.drawerVisible = false;
        this.resetProductionProcessesData();
    }

    drop(event: CdkDragDrop<string[]>): void {
        if (!this.fieldsReadOnly && !this.orderStarted) {
            moveItemInArray(this.productionProcessTableRows, event.previousIndex, event.currentIndex);
        }
    }

    onRouteChange(route: ProductionRouteDto): void {
        this.productionProcessTableRows = [];
        this.selectedProductionProcesses = [];

        route.productionProcesses?.forEach((process) => {
            const foundProcess = this.productionProcessess.find((p) => p.id === process.productionProcessId);

            if (foundProcess) {
                if (!this.selectedProductionProcesses.includes(foundProcess as ProductionProcessDto)) {
                    this.selectedProductionProcesses = [...this.selectedProductionProcesses, foundProcess as ProductionProcessDto];
                }

                this.productionProcessTableRows.push({
                    productionProcess: foundProcess,
                    description: foundProcess.name,
                    rawMaterialsUsed: [],
                    rawMaterialsToUse: [],
                    finalProducts: [],
                    machine: null,
                    assess: null
                });

                this.previousProductionProcessTableRows = [...this.productionProcessTableRows.map(row => row.productionProcess!)];
            }
        });
    }

    onProductionProcessessChange(newSelectedProcessess: ProductionProcessDto[], updatedFromScoket: boolean = false): void {
        if (newSelectedProcessess.length === 0 && this.previousProductionProcessTableRows.length === 0) {
            return;
        }

        const addedProcesses = newSelectedProcessess.filter(process => {
            const prevProcess = this.previousProductionProcessTableRows.find(prevProcess => prevProcess.id === process.id);
            return !prevProcess || prevProcess.id !== process.id;
        });

        addedProcesses.forEach(addedProcess => {
            this.productionProcessTableRows.push({
                productionProcess: addedProcess,
                description: addedProcess.name,
                rawMaterialsToUse: [],
                rawMaterialsUsed: [],
                finalProducts: [],
                machine: null,
                assess: null
            });

            this.productionProcessTableRows = _.cloneDeep(this.productionProcessTableRows);
        });

        const removedProcesses = this.previousProductionProcessTableRows.filter(prevProcess =>
            !newSelectedProcessess.some(newProcess => newProcess.id === prevProcess.id)
        );

        for (const removedProcess of removedProcesses) {
            const processRow = this.productionProcessTableRows.find(row => row.productionProcess!.id === removedProcess.id);

            if (processRow && this.isProcessLocked(processRow)) {
                this.toast.error(`No se puede eliminar el proceso "${removedProcess.name || 'proceso'}" porque está en marcha. Si es necesario eliminarlo, póngase en contacto con el soporte técnico.`);
                this.selectedProductionProcesses = [...this.previousProductionProcessTableRows];
                return;
            }
            this.productionProcessTableRows = this.productionProcessTableRows.filter(row => row.productionProcess!.id !== removedProcess.id);
        }

        if (!updatedFromScoket) {
            this.routeSelected = undefined;
        }

        this.previousProductionProcessTableRows = [...newSelectedProcessess];
        this.selectedProductionProcesses = [...newSelectedProcessess];
    }

    cloneProductionOrderProcess(index: number): void {
        try {
            const newSelectedProductionProcesses: ProductionOrderProcessDto = _.cloneDeep(this.productionProcessTableRows[index]) as ProductionOrderProcessDto;
            delete newSelectedProductionProcesses.id;

            if (!newSelectedProductionProcesses) {
                this.toast.create('error', 'No se ha encontrado el proceso de la orden de producción para clonar');
                throw new Error('No se ha encontrado el proceso de la orden de producción para clonar');
            }

            if (this.drawerMode === DrawerMode.EDIT) {
                newSelectedProductionProcesses.rawMaterialsUsed = [];
                newSelectedProductionProcesses.rawMaterialsToUse = [];
                newSelectedProductionProcesses.finalProducts = [];
                newSelectedProductionProcesses.status = undefined;
                newSelectedProductionProcesses.machine = null;
            }


            this.productionProcessTableRows.push(newSelectedProductionProcesses);
            this.routeSelected = undefined;
        } catch (error: any) {
            this.toast.create('error', `Error clonando el proceso de la orden de producción. Error: ${error.message}`);
        }
    }

    async removeProductionOrderProcess(event: Event, idx: number): Promise<void> {
        try {
            event.preventDefault();

            const processToDelete = this.productionProcessTableRows[idx];

            if (this.isProcessLocked(processToDelete)) {
                this.toast.error(`No se puede eliminar el proceso "${processToDelete.productionProcess?.name || 'proceso'}" porque está en marcha. Si es necesario eliminarlo, póngase en contacto con el soporte técnico.`);
                return;
            }

            const processDeleted = this.productionProcessTableRows.splice(idx, 1);
            this.previousProductionProcessTableRows.splice(idx, 1);

            if (!this.productionProcessTableRows.find(row => row.productionProcess!.id === processDeleted[0].productionProcess!.id)) {
                this.selectedProductionProcesses = this.selectedProductionProcesses.filter(process => process.id !== processDeleted[0].productionProcess!.id);
            }

            this.routeSelected = undefined;

            this.toast.success(`Proceso "${processDeleted[0].productionProcess?.name}" eliminado correctamente`);

        } catch (error: any) {
            this.toast.error(`Error eliminando el proceso de la orden de producción. Error: ${error.message}`);
        }
    }

    compareById(o1: any, o2: any): boolean {
        return o1 && o2 ? o1.id === o2.id : o1 === o2;
    }

    onAddFinalProducts(productionOrderProcess: ProductionOrderProcessDto, orderProcessIndex: number) {
        const modal = this.modalService.create({
            nzContent: ModalSelectFinalProductsComponent,
            nzStyle: { width: '90%', top: '15%' },
            nzBodyStyle: { height: '50vh' },
            nzClosable: false,
            nzFooter: null,
            nzData: {
                nzTitle: this.isNewOrder ? `Añadir producto/s final/es - Proceso ${productionOrderProcess?.productionProcess.name} ` : `Producto/s final/es - Proceso ${productionOrderProcess?.productionProcess.name} `,
                articles: this.articles,
                articlesBatches: this.articlesBatches,
                productionOrderProcess: productionOrderProcess
            }
        });

        modal.componentInstance?.emitService.subscribe(async (finalProducts: FinalProductDto[]) => {
            if (!finalProducts || finalProducts.length === 0) {
                modal.close();

                return;
            }

            this.productionProcessTableRows[orderProcessIndex].finalProducts = finalProducts;
            modal.close();
        });
    }

    onShowAddRawMaterialsToUse(productionOrderProcess: ProductionOrderProcessDto) {
        const modal = this.modalService.create({
            nzContent: ModalAddRawMaterialsToUseComponent,
            nzStyle: { width: '90%', top: '15%' },
            nzBodyStyle: { height: '50vh' },
            nzClosable: false,
            nzFooter: null,
            nzData: {
                nzTitle: `Materias primas a utilizar - Proceso ${productionOrderProcess?.productionProcess.name} `,
                orderProcessId: -1,
                rawMaterialsToUse: productionOrderProcess.rawMaterialsToUse,
                finalProducts: productionOrderProcess.finalProducts,
                isLocked: this.isProcessLocked(productionOrderProcess),
            }
        });

        modal.componentInstance?.emitService.subscribe((rawMaterialsToUse: RawMaterialToUseDto[]) => {
            productionOrderProcess.rawMaterialsToUse = rawMaterialsToUse;

            modal.close();
        });
    }

    showWithProductionOrdersPermissions(btnName: string): boolean {
        const permissionMainKey: string = 'productionOrders';

        return this.permissionService.canRead(permissionMainKey, `${btnName}`);
    }

    canMainSubKey(permissionMainKey: string): boolean {

        return this.permissionService.canRead(permissionMainKey, '');
    }

    getIdColumnValue(order: ProductionOrderDto): string {
        return order.productionOrderProcesses?.length &&
            order.productionOrderProcesses[order.productionOrderProcesses.length - 1]
                ?.finalProducts?.[0]?.articleBatch?.batchNumber || '';
    }

    isProcessLocked(process: ProductionOrderProcessDto): boolean {
        if (!process.status) {
            return false;
        }

        return process.status.id === StatusEnum.IN_PROGRESS ||
            process.status.id === StatusEnum.FINISHED ||
            process.status.id === StatusEnum.PAUSED;
    }

    private isValidForm(order: ProductionOrderDto): boolean {
        if (order.description == undefined || order.description === "") {
            this.toast.error('La descripción es requerida');
            return false;
        }

        if (!order.priorityId) {
            this.toast.error('La prioridad es requerida');
            return false;
        }

        if (!order.customers) {
            this.toast.error('El cliente es requerido');
            return false;
        }

        if (this.productionProcessTableRows.length === 0) {
            this.toast.error('Al menos un proceso es requerido');
            return false;
        }

        for (let i = 0; i < this.productionProcessTableRows.length; i++) {
            const productionOrderProcess = this.productionProcessTableRows[i];

            if (!productionOrderProcess.machine) {
                this.toast.error(`La máquina es requerida para el proceso ${i + 1}`);
                return false;
            }

            if (productionOrderProcess.finalProducts && productionOrderProcess.finalProducts.length <= 0) {
                this.toast.error(`El producto final es requeridos para el proceso ${i + 1}`);
                return false;
            }

            if (productionOrderProcess.rawMaterialsToUse.length > 0) {
                for (let j = 0; j < productionOrderProcess.rawMaterialsToUse.length; j++) {
                    const rawMaterialToUse = productionOrderProcess.rawMaterialsToUse[j];

                    if (!rawMaterialToUse.article) {
                        this.toast.error(`El artículo de materia prima es requerido para el proceso ${i + 1}, materia prima ${j + 1}`);
                        return false;
                    }

                    if (!rawMaterialToUse.estimatedQuantity && rawMaterialToUse.estimatedQuantity !== 0) {
                        this.toast.error(`La cantidad de materia prima es requerida para el proceso ${i + 1}, materia prima ${j + 1}`);
                        return false;
                    }

                    if (rawMaterialToUse.estimatedQuantity && rawMaterialToUse.estimatedQuantity < 0) {
                        this.toast.error(`La cantidad de materia prima debe ser mayor o igual que 0 para el proceso ${i + 1}, materia prima ${j + 1}`);
                    }
                }
            }

            if (!productionOrderProcess.finalProducts || productionOrderProcess.finalProducts.length < 0) {
                this.toast.error(`El producto final es requerido para el proceso ${i + 1}`);
                return false;
            }
        }

        return true;
    }

    private resetProductionProcessesData() {
        this.selectedProductionProcesses = [];
        this.previousProductionProcessTableRows = [];
        this.selectedUsers = [];
        this.selectedEditOrder = new ProductionOrderDto();
    }

    private saveExpandedOrderIds(): void {
        this.expandedOrderIds = this.productionOrdersFiltered.filter(order => order.expand).map(order => order.id);
    }

    private restoreExpandedOrderState(): void {
        this.productionOrdersFiltered.forEach(order => {
            order.expand = this.expandedOrderIds.includes(order.id);
        });
    }

    private getVisibleMachinesForUser() {
        const canSelectAnyMachine = this.showWithProductionOrdersPermissions('canSelectAnyMachine');

        if (canSelectAnyMachine) {
            this.selectableMachines = this.machines;
            this.multipleMachines = true;
        } else {
            this.multipleMachines = this.loggedScreen?.machines?.length && this.loggedScreen?.machines.length > 1 || false;
            this.selectableMachines = this.loggedScreen?.machines || [];
        }
    }
}
